import { createApp } from './app'

const { app, router, store } = createApp({ app: 'Shirtigo' })

app.$mount('#app')

